import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasEligibilitySchema = withDefaults({
  type: 'tas-eligibility',
  objectExtensions: ['tas-eligibility'],
  fields: [
    {
      kind: 'attribute',
      name: 'code',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasParticipant',
      type: 'tas-participant',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramTemplate',
      type: 'tas-program-template',
      options: {
        async: false,
        inverse: 'tasEligibilities',
      },
    },
  ],
});

export default TasEligibilitySchema;
